'use client';
import {Box} from '@mui/material';
import Container from '@mui/material/Container';
import {styled} from '@mui/material/styles';
import NextLink from 'next/link';
import {Children, type ReactNode} from 'react';
import {Button, type FontSize, Section, SectionHeading} from '../primitives';
import {ListingCarousel} from './ListingCarousel';
import {ListingEmptyState, type ListingEmptyStateProps} from './ListingEmptyState';

export interface CarouselSectionProps {
  title: string;
  subtitle?: string;
  titleMobileSize?: FontSize;
  children?: ReactNode;
  viewAll?: {label: string; href: string; onClick?: () => void};
  empty?: ListingEmptyStateProps;
}

const Footer = styled(Box)(({theme}) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(4),
}));

export function CarouselSection({title, subtitle, titleMobileSize, children, viewAll, empty}: CarouselSectionProps) {
  const isEmpty = Children.count(children) === 0;
  return (
    <Section tone="subtle">
      <Container>
        <SectionHeading title={title} subtitle={subtitle} titleMobileSize={titleMobileSize} subtitleMobileSize="body-2" sx={{mb: 3.25}} />
      </Container>
      {empty && isEmpty ? (
        <Container>
          <ListingEmptyState {...empty} card />
        </Container>
      ) : (
        <ListingCarousel>{children}</ListingCarousel>
      )}
      {viewAll && (
        <Footer>
          <Button variant="contained-light" component={NextLink} href={viewAll.href} onClick={viewAll.onClick}>
            {viewAll.label}
          </Button>
        </Footer>
      )}
    </Section>
  );
}

CarouselSection.displayName = 'CarouselSection';
